module.exports = __webpack_public_path__ + "static/media/header-deco-mobile.f4ae64c4.svg";